



























import { Component, Vue } from 'vue-property-decorator';
import { Form } from 'element-ui';
import * as amplitude from 'amplitude-js';
import { ProductDTO } from '@/api';
import EditingLayout from '@/layouts/EditingLayout.vue';
import { clientsModule } from '@/store';
import services from '@/services';

@Component({
  name: 'subscription-create-page',
  components: {
    EditingLayout,
  },
})
export default class SubscriptionCreatePage extends Vue {
  form: {
    productId: number | null;
    price?: number;
    finishAt?: number
  } = {
    productId: null,
    price: undefined,
    finishAt: undefined,
  };

  products: ProductDTO[] = [];

  get client() {
    return clientsModule.model;
  }

  created() {
    services.productsApi().saleEndpointGetProducts()
      .then(response => response.data)
      .then((products) => {
        this.products = products;
      });
    amplitude.getInstance().logEvent('Открытие страницы добавления подписки');
  }

  onSubmit() {
    (this.$refs.form as Form).validate((valid) => {
      if (valid && this.client && this.client.id && this.form.productId) {
        services.clientsService().clientEndpointCreateClientSubscription(
          this.client.id,
          this.form.productId,
          this.form.price,
          this.form.finishAt,
        ).then(() => {
          this.$router.push({ name: 'client-subscriptions' });
        });
      }
    });
  }

  onClose() {
    this.$router.push({ name: 'client-subscriptions' });
  }
}
